export default "__VITE_ASSET__Cbvjfn0Z__"